var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"venues section"},[_c('h2',[_vm._v(_vm._s(_vm.$t('searchFull.salas')))]),_c('div',{staticClass:"separator"}),_c('slider',{attrs:{"type":'artist',"elements":_vm.venuesEvent.venues}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }